module.exports = __webpack_public_path__ + "static/img/detail_nhl_02.13a1e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/nhl-sustainability-report/detail_nhl_02.jpg
// module id = 262
// module chunks = 2